<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-img
        :src="require('@/assets/logos/icon1.svg')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
      />
      <!--
      <base-title
        size="text-body-1"
        space="4"
        title="MULTI-PURPOSE THEME"
        weight="regular"
      /> -->

      <base-body>
        Borrow it or Rent it out! Strapp is a platform that allows you to borrow
        things you need for short term projects from other people in the Strapp
        community. Rent out things you hardly use and earn some extra cash!
      </base-body>

      <base-btn
        class="mb-12"
        color="white"
        outlined
        href="https://www.strapp.co.za/search"
        rel="noopener"
        target="_blank"
      >
        More Info
      </base-btn>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseInfo",

  props: {
    title: String,
    dark: Boolean
  },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "8553 N. Beach St. Ste. 227<br>Fort Worth, Texas 76137"
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "01 (800) 433 744<br>01 (800) 433 633"
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "john@vuetifyjs.com<br>heather@vuetifyjs.com"
      }
    ]
  })
};
</script>
